import { GET_INPUT_VALIDATION_ON_SUBMIT, GET_INPUT_VALIDATION_ON_SUBMIT_CLEAR } from "constants/actionTypes";
import { submitValidationType } from "type/productValidation";

const submitValidation = (payload: submitValidationType) => {
  const { eventType} = payload;
  if (eventType === 'validate') {
    return {
      type: GET_INPUT_VALIDATION_ON_SUBMIT,
      payload: {
        eventType,
      }
    };
  }
  return {
    type: GET_INPUT_VALIDATION_ON_SUBMIT_CLEAR,
    payload: {
      eventType: '',
    }
  };
};

export default submitValidation;
